import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import { useIntl, FormattedMessage } from 'react-intl';
import { Page } from '../../../components/page/page';

const useStyles = makeStyles(() => ({
  modal: {
    maxWidth: 500,
    margin: '150px auto 50px',
  },
}));

export const LogoutScreen = () => {
  const intl = useIntl();

  const classes = useStyles();

  return (
    <div className={classes.modal}>
      <Page>
        <Page.Section>
          <Page.Header
            title={intl.formatMessage({ id: 'VPUK__LOGOUT__TITLE' })}
          />

          <Grid container>
            <FormattedMessage id="VPUK__LOGOUT__TEXT" />
          </Grid>
        </Page.Section>
      </Page>
    </div>
  );
};
